import CheckboxRow from './CheckboxRow';

export default CheckboxRow;
